import { getExampleFromSchema } from "../../spec-getters/get-example-from-schema.js";
import { json2xml } from "@scalar/helpers/file/json2xml";
import { getResolvedRef } from "@scalar/workspace-store/helpers/get-resolved-ref";
const objectToFormParams = (obj) => {
  const params = [];
  for (const [key, value] of Object.entries(obj)) {
    if (value === void 0 || value === null) {
      continue;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        params.push({ name: key, value: String(item) });
      }
    } else if (typeof value === "object") {
      const nestedParams = objectToFormParams(value);
      for (const param of nestedParams) {
        params.push({ name: `${key}.${param.name}`, value: param.value });
      }
    } else {
      params.push({ name: key, value: String(value) });
    }
  }
  return params;
};
const processBody = ({ content, contentType, example }) => {
  const _contentType = (contentType || Object.keys(content)[0]) ?? "";
  const isFormData = _contentType === "multipart/form-data" || _contentType === "application/x-www-form-urlencoded";
  const isXml = _contentType === "application/xml";
  if (example) {
    if (isFormData && typeof example === "object" && example !== null) {
      return {
        mimeType: _contentType,
        params: objectToFormParams(example)
      };
    }
    if (isXml && typeof example === "object" && example !== null) {
      return {
        mimeType: _contentType,
        text: json2xml(example)
      };
    }
    return {
      mimeType: _contentType,
      text: JSON.stringify(example)
    };
  }
  const contentSchema = getResolvedRef(content[_contentType]?.schema);
  if (contentSchema) {
    const extractedExample = getExampleFromSchema(contentSchema, {
      mode: "write",
      xml: isXml
    });
    if (extractedExample !== void 0) {
      if (isFormData && typeof extractedExample === "object" && extractedExample !== null) {
        return {
          mimeType: _contentType,
          params: objectToFormParams(extractedExample)
        };
      }
      if (isXml && typeof extractedExample === "object" && extractedExample !== null) {
        return {
          mimeType: _contentType,
          text: json2xml(extractedExample)
        };
      }
      return {
        mimeType: _contentType,
        text: JSON.stringify(extractedExample)
      };
    }
  }
  return {
    mimeType: _contentType,
    text: "null"
  };
};
export {
  processBody
};
//# sourceMappingURL=process-body.js.map
